export default __webpack_public_path__ + "static/media/logo-1.967abb2c.png";